import './App.css';
import {Router, Link, Routes, Route} from 'react-router-dom';
import LandingPage from './Components/LandingPage/LandingPage';
import Login from './Components/Body/Login/Login';
import Error from "./Components/Error/Error";
import Forbidden from "./Components/Error/Forbidden";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App(props) {
    return (

        <div className="">
            <ToastContainer position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover />
        <Routes>
            <Route path='/' element={<Login/>}/>
            <Route path='/:login' exact element={<Login/>}/>
            <Route path="/landingpage" element={<LandingPage/>}/>;
            <Route path="/unauthorized" element={<Forbidden/>}/>;
            <Route path="*" element={<Error/>}/>;
        </Routes>
    </div>
    );
}

export default App;
